import { useSuspensionInfoFacade } from './useSuspensionInfoFacade';
import { useBillingAccount, usePlanGroup } from '../queries';

/**
 * Fetches the plan group for the current user.
 *
 * @param planGroupIdOverride - Optional plan group ID to show instead of the user's
 *   own group. Suspended users' pre-suspend group always takes priority over this
 *   override. Pass `microEmail3PlGroupId` (109) from useEmailPlansWidget so paid
 *   Micro Email users see the 3PL plans on Plans & Pricing without burdening every
 *   other caller with extra usePlanDetail / useUpgradePlanPromotion hook calls.
 */
export const usePlanGroupFacade = (planGroupIdOverride?: number) => {
  const billingAccountQuery = useBillingAccount();
  const suspensionInfoQuery = useSuspensionInfoFacade();
  const preSuspendPlanGroupId = suspensionInfoQuery?.data?.getPreSuspendPlanGroupId();

  // Suspended users' pre-suspend group takes highest priority.
  // For all other users the override (e.g. group 109 for paid Micro Email) is used
  // if supplied; otherwise the user's own group is derived from the plan group API.
  const resolvedPlanGroupId = planGroupIdOverride ?? preSuspendPlanGroupId;

  const planGroupQuery = usePlanGroup(billingAccountQuery.data?.getCurrency(), 0, undefined, resolvedPlanGroupId);

  return planGroupQuery;
};
